<script setup lang="ts">
import { Moon, Sun } from "@lucide/vue";
import { onMounted, ref } from "vue";
import Button from "./ui/Button.vue";

type ThemeMode = "light" | "dark";

const theme = ref<ThemeMode>("dark");
const mounted = ref(false);

function applyTheme(t: ThemeMode) {
  const root = document.documentElement;
  root.classList.toggle("dark", t === "dark");
  root.dataset.theme = t;
  localStorage.setItem("cpabuddy-theme", t);
}

onMounted(() => {
  const saved = localStorage.getItem("cpabuddy-theme");
  const next: ThemeMode = saved === "light" ? "light" : "dark";
  applyTheme(next);
  theme.value = next;
  mounted.value = true;
});

function toggleTheme() {
  const next: ThemeMode = theme.value === "dark" ? "light" : "dark";
  applyTheme(next);
  theme.value = next;
}
</script>

<template>
  <Button
    type="button"
    variant="outline"
    size="icon"
    aria-label="切换主题"
    class="border-border"
    @click="toggleTheme"
  >
    <Sun v-if="theme === 'dark'" class="h-4 w-4" />
    <Moon v-else class="h-4 w-4" />
  </Button>
</template>
